<label><strong>{{label}}</strong></label>

<p-image [src]="decodedImageStr" [alt]="viewerAlt" [preview]="enablePreview"></p-image>

<div [hidden]="!enableEdit">
  <p-fileUpload #imageUpload id="imageUpload" name="imageUpload"
                (onClear)="onFileRemove()"
                [accept]="acceptedFileTypes"
                [maxFileSize]="maxFileSize"
                (onSelect)="onFileAdd($event)"
                [chooseIcon]="chooseIcon"
                [cancelIcon]="cancelIcon"
                [showUploadButton]="false"
                [showCancelButton]="cancelEnabled"
                styleClass="p-imageupload">
  </p-fileUpload>
</div>
